module.exports = __webpack_public_path__ + "img/制御工学5_6_5.9711be91.png";